import { render } from "./PencilThinIcon.vue?vue&type=template&id=5f15bb88"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__